// Criando um contexto para a função showForm
import React, { useState } from 'react';
import FormContext from '../contexts/FormContext';

export const ModalFormToggler = ({ children }) => {
  const [display, setDisplay] = useState('none');

  const toggleBodyOverFlowY = (method) => {
    document.body.style.overflowY = method; 
  };

  const showForm = () => {
    setDisplay('flex');
    toggleBodyOverFlowY('hidden');
  };

  const hiddenForm = () => {
    setDisplay('none');
    toggleBodyOverFlowY('auto');
  };

  const avoidPropagation = (event) => {
    event.stopPropagation();
  }

  const value = {
    display,
    showForm,
    hiddenForm,
    avoidPropagation,
  };

  return (
    <FormContext.Provider value={value}>
        {children}
    </FormContext.Provider>
  );
};
